import React from 'react';
import TextBox from './TextBox';
const TextArea = p => {
  return <TextBox {...p} isTextArea />;
};
export default TextArea;